<template>
  <div>
    <div>
      <div class="chat" v-chat-scroll="{ always: false }">
        <div v-for="message in messages" :key="message.MessageId">
          <li v-if="message.IsSitter" class="right">
            <span class="chat-img pull-left"></span>
            <div class="chat-body clearfix">
              <p class="chat-from">
                {{ message.MessageText }}
                <small style="padding: 5px" class="pull-right"
                  ><span class="glyphicon glyphicon-time"></span
                  >{{ sentDate(message.SentDate) }}</small
                >
              </p>
            </div>
          </li>
          <li v-else class="left clearfix">
            <span class="chat-img pull-right"></span>
            <div class="chat-body clearfix">
              <p class="chat-to">
                {{ message.MessageText
                }}<small style="padding: 5px" class="pull-right"
                  ><span class="glyphicon glyphicon-time"></span
                  >{{ sentDate(message.SentDate) }}</small
                >
              </p>
            </div>
          </li>
        </div>
      </div>
      <div class="input-group">
        <input
          :disabled="preventChat"
          class="form-control input-text"
          placeholder=""
          row="3"
        />
        <span :disabled="preventChat" class="input-group-addon btn">Send</span>
      </div>
    </div>
  </div>
</template>

<script>
const API_URL = "https://www.dupaws.com/services/";
export default {
  name: "chat",
  props: ["transactionId", "preventChat", "submittedDate"],
  data() {
    return {
      sender: "",
      messages: [],
      newMessage: "",
      scrollPosition: "",
    };
  },
  updated() {},
  methods: {
    sentDate: function (date) {
      var submittedDate = moment(this.submittedDate);
      return moment(date).fromNow(submittedDate);
    },
  },
  mounted: function () {
    var self = this;

    $.ajax({
      type: "GET",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "Authorization",
          "bearer " + localStorage.getItem("access_token")
        );
      },
      url: API_URL + "api/admin/getReservationMessages/" + self.transactionId,
      dataType: "json",
      crossDomain: true,
      contentType: "application/json; charset=utf-8",
      success: function (data) {
        if (data.length > 0) self.messages = data;
      },
      error: function (data, status, error) {},
    });

    this.refreshInterval = setInterval(function () {
      self.$forceUpdate();
    }, 15000);
  },
  computed: {},
};
</script>
<style scoped>
.chat {
  background: #fff;
  list-style: none;
  padding: 10px;
  overflow-y: scroll;
  height: 250px;
  box-shadow: 0 3px #ccc;
  border: 1px;
  border-radius: 5px;
  border-style: solid;
  border-color: #c7c6c6;
  border-radius: 5px;
}

.chat-from {
  background-color: #b8ebcb;
  border-radius: 8px;
  padding: 10px;
  word-wrap: break-word;
  overflow: hidden;
}

.chat-to {
  background-color: #e2ccf0;
  border-radius: 8px;
  padding: 10px;
  word-wrap: break-word;
  overflow: hidden;
}

.chat li {
  padding-bottom: 10px;
}

.chat li.left .chat-body {
  margin-left: 60px;
}

.chat li.right .chat-body {
  margin-right: 60px;
}

.chat li .chat-body p {
  margin: 0;
  color: #777777;
}

.panel .slidedown .glyphicon,
.chat .glyphicon {
  margin-right: 5px;
}

.panel-body {
  overflow-y: scroll;
  height: 250px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

::-webkit-scrollbar {
  width: 12px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #555;
}
</style>



// WEBPACK FOOTER //
// ChatHistory.vue?e035ec54